
import { COMPONENT_SOURCE_TEMPLATES, EXPOSED_SYMBOLS } from '@aeppic/dynamic-components-v3'
import * as Types from '@aeppic/types'
import Vue from '../../externals/vue.js'

import { EditableDocument } from '../../model'
import DynamicComponent from '../dynamic/dynamic-component'
import { perf } from '../perf.js' 
import editFunctions from '../utils/edit-ref-functions'
import createEventForwarders from '../utils/create-event-forwarders'

export default {
  /* tslint:disable */
  render () {
    const _vm=this;
    const _h=_vm.$createElement;
    const _c=_vm._self._c||_h;
    
    return (_vm.dynamicComponent?.id) ? _c(_vm.dynamicComponent.id,
      {
        key: _vm.componentKey,
        tag: 'component',
        style: _vm.isComponentManuallyHidden ? { display: 'none' } : undefined,
        props: {
          'Aeppic': _vm.Aeppic,
          'params': _vm.params,
          'layout': _vm.dynamicComponent.document,
          'hide-component': _vm.hideComponent,
          'show-component': _vm.showComponent,
          'is-component-hidden': _vm.isComponentManuallyHidden,
        },
        on: createEventForwarders(_vm._events, _vm)
      }) : _vm._e()
  },
  renderError(h, err) {
    return h('pre', { staticClass: 'ae-error', style: { color: 'red' }}, 'ae-layout:' + this.layoutId + ' ' +  err.stack)
  },
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  props: { 
    layoutId: String,
    params: Object,
    watchLayout: {
      type: Boolean,
      default: null
    },
    watchLayoutRevisions: {
      type: Boolean,
      default: null
    }
  },
  data() {
    const Aeppic = this.getAeppicContext('ae-layout-selector:-')

    return {
      Aeppic,
      dynamicComponent: null,
      refreshing: false,
      componentKey: 0,
      isComponentManuallyHidden: false,
    }
  },
  computed: {
    pageDocumentId() {
      return this.params?.pageDocumentId ?? ''
    }
  },
  mounted() {
    this.Aeppic.setContextRootElement(this.$el)
    this.loadLayout()
  },
  updated() {
  },
  created: function() {
    // console.log('layout created')
    const isDeveloper = this.Aeppic.Account && this.Aeppic.Account.data.allowDevMode
    const watch = typeof this.watchLayout === 'boolean' ? this.watchLayout : isDeveloper
    const watchRevisions = typeof this.watchLayoutRevisions === 'boolean' ? this.watchLayoutRevisions : isDeveloper

    this.loadLayout = async () => {
      const id = this.layoutId
      await perf.track('layout:component', async () => {
      const layoutDocument = await this.Aeppic.get(id)

      // Clean up old component if it exists
      if (this.dynamicComponent) {
        this.dynamicComponent.destroy()
      }

      if (layoutDocument) {
        this.Aeppic.renameContext(`ae-layout-selector:${id}:${layoutDocument?.data.name ?? '?'}`)
        
        // Create a NEW DynamicComponent instance
        this.dynamicComponent = new DynamicComponent('layout', this.Aeppic, {
          formId: 'layout-form',
          template: COMPONENT_SOURCE_TEMPLATES.layout,
          exposedSymbols: EXPOSED_SYMBOLS.layout,
          watch,
          watchRevisions
        })
        
        // Load the document into the new component
        this.componentKey++
        await this.dynamicComponent.refresh(layoutDocument)
        
        // Increment key to force Vue to create a new component instance
      } else {
        this.Aeppic.context.updateName?.(`ae-layout-selector:${id}:-}`)
        this.componentKey++
        this.dynamicComponent = null
      }
      }, id || '')
    }

  },
  methods: {
    hideComponent() {
      this.isComponentManuallyHidden = true
    },
    showComponent() {
      this.isComponentManuallyHidden = false
    }
  },
  beforeDestroy() {
    if (this.dynamicComponent) {
      this.dynamicComponent.destroy()
    }
    this.Aeppic.release()
  },
  watch: {
    layoutId(id) {
      this.loadLayout()
    },
    pageDocumentId(id, oldId) {
      if (id !== oldId) {
        this.isComponentManuallyHidden = false
      }
    },
    // params: {
    //   deep: true,
    //   handler() {
    //     this.render()
    //   }
    // }
  }
}
